// @ai-generated 2026-08-26T13:23:32+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { EnumMessageLevel } from '@synqo/frontend-component-library';

/** The looks a message can have, named the way the component library names its toast variants. */
export type MessageVariant = 'info' | 'success' | 'warning' | 'error';

/**
 * What a message level looks like. Mirrors the component library's own toast-variant mapping, which
 * is not exported from its entry point — until it is, this is the one place the client decides that,
 * so a toast, a notification and the record it points at can never disagree about a level.
 */
export function getVariantByMessageLevel(level: EnumMessageLevel): MessageVariant {
    switch (level) {
        case EnumMessageLevel.Danger:
            return 'error';
        case EnumMessageLevel.Warning:
            return 'warning';
        case EnumMessageLevel.Success:
            return 'success';
        case EnumMessageLevel.Information:
        default:
            return 'info';
    }
}

/** The button variant that belongs to a message variant, mirroring the library's own pairing. */
export function getButtonVariantByMessageVariant(variant: MessageVariant) {
    switch (variant) {
        case 'info':
            return 'secondary';
        case 'warning':
        case 'error':
            return 'warning';
        case 'success':
        default:
            return 'primary';
    }
}
